import * as React from "react";
import {connect} from "react-redux";
import {Action, Dispatch} from "redux";
import {ClientBookmark} from "../../domain/model/client_bookmark";
import {createClientScoutCustomerActionCreator} from "../action/client_scout_customer_action";
import ClientScoutCustomerComponent from "../component/client/scout_customer/client_scout_customer";
import {
    createScoutCustomerDispatcher,
    IClientScoutCustomerDispatcher,
} from "../dispatcher/client_scout_customer_dispatcher";
import {
    CreateClientBookmarkByClientRequest,
    CreateScoutCustomerByClientRequest,
    DeleteClientBookmarkByClientRequest,
    DeleteHighlightsByClientRequest,
    GetCustomerByClientRequest,
} from "../request/scout_request";
import {AppState} from "../store/app_state";
import {AuthState} from "../store/auth_state";
import {ClientScoutCustomerState} from "../store/client_scout_customer_state";
import {Client} from "src/domain/model/client";

export enum PageMode {
    StepScoutStep1 = 1,
    StepScoutStep2 = 2,
    StepScoutStep3 = 3,
}

interface IProps {
    state: ClientScoutCustomerState;
    authState: AuthState;
    dispatcher: IClientScoutCustomerDispatcher;
    history: any;
    location: any;
    match: any;
}

interface IState {
    isInit: boolean;
    pageMode: PageMode;
    defaultText: string;
}

export class ClientScoutCustomer extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            isInit: true,
            pageMode: PageMode.StepScoutStep1,
            defaultText: "",
        };
    }

    public componentDidMount() {
        const customerId: string = this.props.match.params.customerId;
        const req: GetCustomerByClientRequest = new GetCustomerByClientRequest();
        req.customerId = customerId;
        this.props.dispatcher.getCustomer(req);
    }

    // page切り替え時に表示をトップにする
    public componentDidUpdate(prevProps: IProps, prevState: IState) {
        // pageが切り替わった時
        if (this.state.pageMode !== prevState.pageMode) {
            window.scrollTo(0, 0);
        }
        // id 変更があった時
        if (
            prevProps.match.params.customerId !== this.props.match.params.customerId
        ) {
            const customerId: string = this.props.match.params.customerId;
            const req: GetCustomerByClientRequest = new GetCustomerByClientRequest();
            req.customerId = customerId;
            this.props.dispatcher.getCustomer(req);
            window.scrollTo(0, 0);
        }

        // init処理の終了
        const isInitFinished: boolean =
            this.state.isInit &&
            !this.props.state.isLoading &&
            prevProps.state.isLoading;
        if (isInitFinished) {
            return this.setState({isInit: false});
        }
    }

    public componentWillUnmount(): void {
        const req: DeleteHighlightsByClientRequest =
            new DeleteHighlightsByClientRequest();
        this.props.dispatcher.deleteHighlights(req);
    }

    public render(): JSX.Element {
        const {state} = this.props;
        const {isInit} = this.state;
        const {
            isLoading,
            customer,
            company,
            jobCareers,
            pastCaseProjects,
            projects,
            clientBookmarks,
            highlights,
            sameOccupationCustomers,
            jobCareersWithSameOccupationCustomerID,
        } = state;
        const pageMode: PageMode = this.state.pageMode;
        const customerId: string = customer ? customer.id : "";
        const isClientBookmark: boolean = this.checkClientBookmark(
            customerId,
            clientBookmarks
        );
        const client: Client | null = this.props.authState.user
            ? this.props.authState.user.client
            : null;

        if (company != null && client != null && this.state.defaultText === "") {
            this.setState({
                defaultText: `
初めまして、${company.name}の${client.name}と申します。
この度は弊社の掲載案件に関してご連絡をさせて頂きました。
案件の詳細などについて一度ご面談の機会を頂けないでしょうか。
オンラインにて以下の日程で、ご都合いかがでしょうか。
○○月○○日（〇） ○○：○○-○○：○○ 
○○月○○日（〇） ○○：○○-○○：○○
○○月○○日（〇） ○○：○○-○○：○○
ご返信を賜れますと幸いです。
どうぞよろしくお願い申し上げます。
`
            })
        }
        
        return (
            <ClientScoutCustomerComponent
                isLoading={isLoading}
                isInit={isInit}
                customer={customer}
                sameOccupationCustomers={sameOccupationCustomers}
                jobCareersWithSameOccupationCustomerID={
                    jobCareersWithSameOccupationCustomerID
                }
                company={company}
                defaultText={this.state.defaultText}
                jobCareers={jobCareers}
                highlights={highlights}
                pastCaseProjects={pastCaseProjects}
                projects={projects}
                pageMode={pageMode}
                isClientBookmark={isClientBookmark}
                clientBookmarks={clientBookmarks}
                handleCreateScout={this.handleCreateScout}
                handleNextStep={this.handleNextStep}
                handlePreviousStep={this.handlePreviousStep}
                handleCreateClientBookmark={this.handleCreateClientBookmark}
                handleDeleteClientBookmark={this.handleDeleteClientBookmark}
            />
        );
    }

    private handlePreviousStep = (values: any): void => {
        this.setState({pageMode: this.state.pageMode - 1});
    };

    private handleNextStep = (values: any): void => {
        this.setState({pageMode: this.state.pageMode + 1});
    };

    private handleCreateScout = (values: any): void => {
        const req: CreateScoutCustomerByClientRequest =
            new CreateScoutCustomerByClientRequest();
        const customerID: string = values.customer.id;
        const projectID: string = values.projectId;
        const message: string = values.message;
        req.req = {
            customerID,
            projectID,
            message,
        };

        if (req.req.message === this.state.defaultText) {
            alert("メッセージを編集してください");
            return;
        }

        this.props.dispatcher.createScoutCustomer(req);
    };

    private checkClientBookmark = (
        customerId: string,
        clientBookmarks: ClientBookmark[]
    ): boolean => {
        let res: boolean = false;

        if (clientBookmarks) {
            clientBookmarks.map((item: ClientBookmark) => {
                if (item.customerID === customerId) {
                    res = true;
                }
            });
        }

        return res;
    };

    private handleCreateClientBookmark = (event: any): void => {
        const req: CreateClientBookmarkByClientRequest =
            new CreateClientBookmarkByClientRequest();
        const customerId: string = event.currentTarget.value;
        req.customerId = customerId;
        this.props.dispatcher.createClientBookmark(req);
    };

    private handleDeleteClientBookmark = (event: any): void => {
        const req: DeleteClientBookmarkByClientRequest =
            new DeleteClientBookmarkByClientRequest();
        const customerId: string = event.currentTarget.value;
        req.customerId = customerId;
        this.props.dispatcher.deleteClientBookmark(req);
    };
}

const mapStateToProps = (state: AppState) => {
    return {
        state: state.clientScoutCustomerReducer,
        authState: state.authReducer,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {
        dispatcher: createScoutCustomerDispatcher(
            dispatch,
            createClientScoutCustomerActionCreator()
        ),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ClientScoutCustomer);



// WEBPACK FOOTER //
// ./src/presentation/container/client_scout_customer_container.tsx